export const styles = {
  head: {
    backgroundColor: '#F0ECE4',
    borderRadius: '4px',
  },
}
